import {
  Box,
  Card,
  RadioButton,
  Title,
  WizardStepRenderParams,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { FormWizardData } from '../types'

type Props = {
  disabled?: boolean
}

export const FormTypeStep = ({
  data,
  onDataChanged,
  disabled = false,
}: WizardStepRenderParams<FormWizardData> & Props) => {
  return (
    <Box gap="s32" width="s600">
      <Title title={i18n.t('trainings.surveys.create.survey_type')} variant="500" />
      <Box gap="s16">
        <Card
          onClick={() =>
            onDataChanged({ ...data, trainingFormType: 'satisfaction', anonymous: true })
          }
        >
          <Card.Title
            action={
              <RadioButton
                value={data.trainingFormType}
                checked={data.trainingFormType === 'satisfaction'}
                onChange={() =>
                  onDataChanged({ ...data, trainingFormType: 'satisfaction', anonymous: true })
                }
                disabled={disabled}
              />
            }
          >
            {i18n.t('trainings.surveys.create.satisfaction.title')}
          </Card.Title>
          <Card.Description>
            {i18n.t('trainings.surveys.create.satisfaction.description')}
          </Card.Description>
        </Card>
        <Card onClick={() => onDataChanged({ ...data, trainingFormType: 'effectiveness' })}>
          <Card.Title
            action={
              <RadioButton
                value={data.trainingFormType}
                checked={data.trainingFormType === 'effectiveness'}
                onChange={() => onDataChanged({ ...data, trainingFormType: 'effectiveness' })}
                disabled={disabled}
              />
            }
          >
            {i18n.t('trainings.surveys.create.effectiveness.title')}
          </Card.Title>
          <Card.Description>
            {i18n.t('trainings.surveys.create.effectiveness.description')}
          </Card.Description>
        </Card>
      </Box>
    </Box>
  )
}
